import { Component, Vue } from 'vue-property-decorator';
import DxTextBox from 'devextreme-vue/text-box';
import DxSelectBox from 'devextreme-vue/select-box';
import { userModule } from '@/store';
import DxButton from 'devextreme-vue/button';
import cnaeCodeModule from '@/store/modules/cnae-code.module';
import { CnaeCode } from '@/shared/dtos/cnae-code';
import { DxValidator, DxRequiredRule} from 'devextreme-vue/validator';
import { itiMessageService } from '@/iti-core-vue';
import associationModule from '@/store/modules/association.module';
import { Association } from '@/shared/dtos/association';

@Component({
    components: {
        DxTextBox,
        DxSelectBox,
        DxButton,
        DxValidator,
        DxRequiredRule,
    },
})
export default class UserAccount extends Vue {
    public cnaeCode: CnaeCode = new CnaeCode();
    public association: Association = new Association();

    public async created(){
        await userModule.getUserSession();
        await cnaeCodeModule.getCnaeCodes().then(() =>
            this.setCnaeUserCode()
        );
        await associationModule.getAssociations().then(() =>
            this.setAssociations()
        );
    }

    public close() {
        this.$router.back();
    }

    public save() {
        itiMessageService.confirm(this.$tc('account.confirmar'), this.$tc('mensajes.confirmar'), (result) => {
            if(result) {
                if(this.association == null)
                    this.user.associationId = 0;
                else 
                    this.user.associationId = this.association.id;
                this.user.cnaeCodeId = this.cnaeCode.id;
                userModule.UpdateUserSession(this.user)
                .then(() => {itiMessageService.toast(this.$tc('account.success'), 'success', 3000)})
                .catch(() => itiMessageService.toast(this.$tc('account.error'), 'error', 3000));
            }
          });
    }

    public get user(){
        return userModule.userSession;
    }

    public setCnaeUserCode() {
       var code: any = cnaeCodeModule.cnaeCodes.find((cnaeCode: CnaeCode) => cnaeCode.id == userModule.userSession.cnaeCodeId);
       this.cnaeCode = code;
    }

    public setAssociations() {
        var association: any = associationModule.associations.find((association: Association) => association.id == userModule.userSession.associationId);
        this.association = association;
     }

    public get cnaeCodes() {
        return cnaeCodeModule.cnaeCodes;
    }

    public get associations() {
        return associationModule.associations;
    }
}
